module.exports = __webpack_public_path__ + "static/img/top.3b6bbdf4.png";